import React, {useState} from 'react'
import * as Yup from 'yup'
import {useFormik} from 'formik'
import {useNavigate} from 'react-router-dom'
import {ModeleReferentielFournisseurPOT} from '../../../../components/Models'
import FournisseurPOTFields from './FournisseurPOTFileds'

const fournisseurPOTSchema = Yup.object().shape({
  nom: Yup.string().required('Le nom du fournisseur est requis'),
  lien: Yup.string().notRequired(),
})

const ReferentielFournisseurPOTForm = (props) => {
  const navigate = useNavigate()
  const [fournisseurId, setFournisseurId] = useState(props.fournisseurId)
  const initialValue = {...props?.data}
  const [data, setData] = useState<ModeleReferentielFournisseurPOT>(initialValue)
  const [nom, setNom] = useState<string>(initialValue?.nom ?? "")
  const [loading, setLoading] = useState<boolean>(false)
  const [isRequis, setIsRequis] = useState<boolean>(false)
  const [existName, setExistName] = useState<boolean>(false)

  const formik = useFormik<ModeleReferentielFournisseurPOT>({
    initialValues: data,
    validationSchema: fournisseurPOTSchema,
    onSubmit: (values) => {
      setLoading(true)
      setIsRequis(false)
      setExistName(false)

      setTimeout(() => {
        const updatedData = Object.assign({...data}, values)

        if (props?.allFournisseursPOT) {
          if (updatedData?.nom?.trim()?.length === 0) {
            setIsRequis(true);
            setLoading(false);
            return;
          }
          if (props?.allFournisseursPOT?.includes(updatedData?.nom?.trim())) {
            setExistName(true);
            setLoading(false);
            return;
          }
        }

        props.submitForm(updatedData, (response) => {
          formik.resetForm()
          setLoading(false)
        })
      }, 200)
    },
  })

  return (
    <div>
      <form onSubmit={formik.handleSubmit} noValidate className='form'>
        <div className='card-body border-top p-9'>
          <FournisseurPOTFields
            formik={formik}
            isInModal={false}
            nom={nom}
            setNom={setNom}
            isRequis={isRequis}
            existName={existName}
            verifEnCours={null}
          />
        </div>
        <div className='card-footer d-flex justify-content-end py-6 px-9'>
          <button
            type='button'
            className='btn btn-light me-3'
            disabled={loading}
            onClick={() => {
              formik.resetForm()
              navigate(`/referentiel-fournisseur-pot/liste`)
            }}
          >
            Annuler
          </button>
          <button type='submit' className='btn btn-primary' disabled={loading}>
            {!loading && 'Enregistrer'}
            {loading && (
              <span className='indicator-progress' style={{display: 'block'}}>
                Enregistrement...{' '}
                <span className='spinner-border spinner-border-sm align-middle ms-2'></span>
              </span>
            )}
          </button>
        </div>
      </form>
    </div>
  )
}

export {ReferentielFournisseurPOTForm}
